import { useEffect, useState, useContext, useRef} from 'react'
import {  Link, useLocation, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import { MdArrowForwardIos } from "react-icons/md";

import { AppContext } from "../../Context";
import { Loader, Get } from "../inc/Fetch";
import ErrorPage from "./ErrorPage";


import Header from "./Header";
import Footer from "./Footer";


import './css/Product.css'

export default function Content() {

    const { t } = useTranslation();
    const params = useParams();

	const {siteData, siteMenu} = useContext(AppContext); 
    const [site_menu, setsite_menu] = siteMenu;
    
    const [isLoading, setisLoading] = useState(true);
    const [data, setdata] = useState({});
    const [sub, setsub] = useState({});


    // console.log(cart);
    function strip_tags(text) {
        const regex = /(<([^>]+)>)/gi;
        let result = text?.replace(regex, "");
        result = result?.replace(/(\r|\n)/gi, " ").substring(0, 200);

        return result;
    }

    async function loadData() {
        
		let res = await Get("Article/view?_id="+params?.id);

        setdata(res[0]);
        setisLoading(false);
        
    }

    useEffect(() => {

        loadData();

        // if (site_menu?.length) {

        //     let ck = site_menu?.filter(p => p?._id == params?.id);

        //     if (!params?.sub) {
                
        //         if (ck?.length) {
        //             setisLoading(false);
        //             setdata(ck[0]);
        //         }
        //     } else {

                
        //         if (ck?.length && ck[0]?.childs) {
        //             setsub(ck[0]);

        //             let ck2 = ck[0]?.childs?.filter(p => p?._id == params?.sub);
        //             if (ck2?.length) {
        //                 setisLoading(false);
        //                 setdata(ck2[0]);
        //             }
                    
        //         }
                
        //     }
            

        //     setisLoading(false);

        //     window.scrollTo(0, 0);
        // } 
        
    }, [site_menu, params?.id, params?.sub]);



    if (isLoading) {
        return <Loader />;
    }

    if (!data?._id) {
        return <ErrorPage />
    }

    
	return (
		<>
            <Helmet>
                <title>{data?.name}</title>
                <meta name="description" content={strip_tags(data?.full)} />
                <meta property="og:title" content={data?.name} />
                <meta property="og:description" content={strip_tags(data?.full)} />
            </Helmet>

			<Header title={true}/> 

            <div className='articleBodyBox'>

                <nav className='mainWidth pathNames'> 
                    <Link to='/'>{t("home")}</Link>
                
                        <>
                            <MdArrowForwardIos />
                            <Link>{data?.title}</Link>
                        </>

                </nav>

                <div className='mainWidth fullContentBox'>

                    <h1>{data?.title}</h1>

                    <div dangerouslySetInnerHTML={{ __html: data?.full }} className='fulltextInside'>

                    </div>

                </div>
            </div>


            <Footer />
		</>
	)
}
